var GraphConfig = /** @class */ (function () {
    function GraphConfig() {
    }
    return GraphConfig;
}());
export { GraphConfig };
